export const SmallStringMaxLength = 120;
export const BigStringMaxLength = 1200;
export const TextMaxLength = 120000;
//# sourceMappingURL=schemasConstraints.js.map